import { render, staticRenderFns } from "./IdentityOCRv2.vue?vue&type=template&id=7317ea4e&scoped=true&"
import script from "./IdentityOCRv2.vue?vue&type=script&lang=js&"
export * from "./IdentityOCRv2.vue?vue&type=script&lang=js&"
import style0 from "./IdentityOCRv2.vue?vue&type=style&index=0&id=7317ea4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7317ea4e",
  null
  
)

export default component.exports